var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"mt-10",attrs:{"color":"transparent"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('div',[_vm._v("© Copyright "+_vm._s(new Date().getFullYear())+", MWC Sp. z o.o. Kowalewicka 12, 60-002 Poznań ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }